import { render, staticRenderFns } from "./btn-share.mpx?vue&type=template&id=0de432e8&isComponent&outputPath=components%2Fbtn-share79de9198%2Findex"
import script from "./btn-share.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-share79de9198%2Findex"
export * from "./btn-share.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-share79de9198%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports